import styled, { css } from 'styled-components';
import { Button as CustomButton } from '@getinapp/appetizer';
import media from 'styled-media-query';

export const Container = styled.div`
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 1rem 1.5rem;

  ${media.greaterThan('small')`
    max-width: 45rem;

    border-radius: 0 0 1.5rem 1.5rem;
  `}

  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    border-top: 1px solid ${theme.colors.border};
  `}
`;

export const WrapperInfo = styled.div`
  width: 50%;

  display: flex;
  align-items: center;
  justify-content: space-evenly;

  font-size: 1.2rem;
`;

export const Button = styled(CustomButton)`
  height: 30px;

  border-radius: 6px;
  background-color: transparent;

  ${({ theme }) => css`
    border: 1px solid ${theme.colors.black};
    color: ${theme.colors.black};

    font-size: ${theme.font.sizes.xsmall};

    &:hover, &:focus {
      background-color: transparent;
    }
  `}
`;
